<div class="overlay-container">
</div>
<div class="modal show" id="myModal" style="padding-right: 16px; ">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">

        <div class="text-center" id="searchResu">Address Change</div>
        <div class="row no-margin">
          <div class="col-12 col-sm-12 mb-3" [innerHTML]="messageText">
           
          </div>



          <div class="addressChangeBtnContainer mb-3">
          <div >
            <a>
              <button class="btn btn-primary btn-commonbtn  addressChangeBtn"
                (click)="yes()">{{yesButtonText}}</button>
            </a>
          </div>
          <div >
            <a>
              <button class="btn btn-primary btn-commonbtn  addressChangeBtn" (click)="no()">{{noButtonText}}
              </button>
            </a>
          </div>
          <div *ngIf="forgotButtonText">
            <a>
              <button class="btn btn-primary btn-commonbtn  addressChangeBtn" (click)="forgetIt()">{{forgotButtonText}}
              </button>
            </a>
          </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>